<template>
  <el-dialog :title="getTitle" top="50px" :visible.sync="dailogShow" width="80%" :close-on-click-modal="false" :before-close="handleClose" append-to-body @open="handleOpen">
    <el-form ref="postForm" :model="postForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
      <el-row :gutter="20">
        <el-col :span="8" :offset="16">
          <el-form-item prop="stockInCode" label="采购编号" style="margin-bottom: 0px">
            <el-input v-model="postForm.stockInCode" maxlength="50" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">试剂耗材信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="shenqingzheUserId" label="申请者">
            <el-select v-model="postForm.shenqingzheUserId" disabled placeholder="申请者" clearable>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shenqingRiqi" label="申请日期">
            <el-date-picker
              v-model="postForm.shenqingRiqi"
              type="date"
              disabled
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="nishiyongRiqi" label="拟使用日期">
            <el-date-picker
              v-model="postForm.nishiyongRiqi"
              type="date"
              disabled
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="shijihaocaiMingcheng" label="试剂耗材名称" label-width="120px">
            <el-input v-model="postForm.shijihaocaiMingcheng" maxlength="50" placeholder="试剂耗材名称" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="20">
        <el-col :span="8">
          <!-- <el-form-item prop="shiyongzheUserId" label="使用者">
            <el-select v-model="postForm.shiyongzheUserId" placeholder="使用者" disabled>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item> -->
        </el-col>
        <el-col :span="8">
          <el-form-item prop="pingpai" label="品牌">
            <el-input v-model="postForm.pingpai" maxlength="50" placeholder="品牌" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="huohao" label="货号">
            <el-input v-model="postForm.huohao" maxlength="50" placeholder="货号" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="cas" label="CAS号">
            <el-input v-model="postForm.cas" maxlength="50" placeholder="CAS号" disabled />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item prop="guigeQty" label="规格">
            <el-input-number v-model="postForm.guigeQty" placeholder="数量" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item prop="guigeUnit" label="" label-width="0px">
            <el-input v-model="postForm.guigeUnit" maxlength="10" placeholder="单位, 例:ml,克 等 " disabled />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="shenqingUnit" label="/" label-width="20px">
            <el-select v-model="postForm.shenqingUnit" disabled placeholder="包装单位">
              <el-option
                v-for="item in getComboxData('F05')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item prop="shenqingQty" label="申请数量">
            <el-input-number v-model="postForm.shenqingQty" placeholder="申请数量" disabled :controls="false" :precision="2" @change="handleSetZongjia" />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-input v-model="postForm.shenqingUnitText" disabled />
        </el-col>
        <el-col :span="6">
          <el-form-item prop="caigouDanjia" label="总数量">
            <el-input v-model="getQty" style="text-align: right;" placeholder="总数量" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-input v-model="postForm.guigeUnit" disabled />
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">代理商信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item prop="gongHuoGongsi" label="实际供货公司">
            <el-input v-model="postForm.gongHuoGongsi" maxlength="50" placeholder="实际供货公司" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="caigouDanjia" label="采购单价">
            <el-input-number v-model="postForm.caigouDanjia" placeholder="采购单价" disabled :controls="false" :precision="2" @change="handleSetZongjia" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="gonghuoLianxiren" label="联系人">
            <el-input v-model="postForm.gonghuoLianxiren" maxlength="50" placeholder="联系人" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="gonghuoShoujihao" label="手机号">
            <el-input v-model="postForm.gonghuoShoujihao" maxlength="50" placeholder="手机号" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="caigouZongjia" label="采购总价">
            <el-input-number v-model="postForm.caigouZongjia" placeholder="采购总价" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">入库信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="kumingchengDictKey" label="库名称">
            <el-select v-model="postForm.kumingchengDictKey" placeholder="库名称" disabled>
              <el-option
                v-for="item in getComboxData('F02')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="rukuzheUserId" label="库管员">
            <el-select v-model="postForm.rukuzheUserId" placeholder="库管员" disabled>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">课题信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="keshi" label="科室">
            <el-input v-model="postForm.keshi" maxlength="50" placeholder="科室" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="ketiFzrUserId" label="课题负责人">
            <el-select v-model="postForm.ketiFzrUserId" placeholder="课题负责人" disabled>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item prop="ketiMingcheng" label="课题名称">
            <el-input v-model="postForm.ketiMingcheng" maxlength="50" placeholder="课题名称" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="ketiBianhao" label="课题编号">
            <el-input v-model="postForm.ketiBianhao" maxlength="50" placeholder="课题编号" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="shiyanMingcheng" label="实验名称">
            <el-input v-model="postForm.shiyanMingcheng" maxlength="50" placeholder="实验名称" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shiyanBianhao" label="实验编号">
            <el-input v-model="postForm.shiyanBianhao" maxlength="50" placeholder="实验编号" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="yongtu" label="用途">
            <el-input v-model="postForm.yongtu" maxlength="50" placeholder="用途" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="jingfeiLaiyuan" label="经费来源">
            <el-input v-model="postForm.jingfeiLaiyuan" maxlength="50" placeholder="经费来源" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="jingfeiKahao" label="经费卡号">
            <el-input v-model="postForm.jingfeiKahao" maxlength="50" placeholder="经费卡号" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">备注</span></el-divider>
      <el-collapse v-model="activeNames">
        <el-collapse-item title="申请者备注" name="ShengqingRemark">
          <el-form-item>
            <el-input v-model="postForm.shengqingRemark" type="textarea" :rows="3" maxlength="500" disabled />
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="审批者备注" name="ShenPiRemark">
          <el-form-item>
            <el-input v-model="postForm.shenPiRemark" type="textarea" :rows="3" maxlength="500" disabled />
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="采购者备注" name="CaigouRemark">
          <el-form-item>
            <el-input v-model="postForm.caigouRemark" type="textarea" :rows="3" maxlength="500" />
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="库管员备注" name="KuguanRemark">
          <el-form-item>
            <el-input v-model="postForm.kuguanRemark" type="textarea" :rows="3" maxlength="500" disabled />
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button v-if="false" type="primary" @click="handleSave(1)">生成订单</el-button>
      <el-button v-if="false" type="primary" @click="handleUnSave">撤销下单</el-button>
      <el-button v-if="postForm.statusDictKey==='F0101'" type="primary" @click="handleSave(2)">下 单</el-button>
      <el-button v-else type="primary" @click="handleSave(2)">保存订单</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
// import { parseTime } from '@/utils/index'
export default {
  components: {
  },
  props: {
    entityId: { type: Number, default: null }
  },

  data() {
    return {
      dailogShow: false,
      allComboxData: [],
      postForm: {},
      ketiMemberList: [],
      activeNames: ['CaigouRemark'],

      rules: {
        shenqingRiqi: [{ required: true, message: '请选择申请日期', trigger: 'change,blur' }],
        shijihaocaiMingcheng: [{ required: true, message: '请输入试剂耗材名称', trigger: 'change,blur' }],
        // shiyongzheUserId: [{ required: true, message: '请选择使用者', trigger: 'change,blur' }],
        guigeQty: [{ required: true, message: '请输入规格(数量)', trigger: 'change,blur' }],
        guigeUnit: [{ required: true, message: '请输入规格(单位)', trigger: 'change,blur' }],
        shenqingQty: [{ required: true, message: '请输入申请数量', trigger: 'change,blur' }],
        shenqingUnit: [{ required: true, message: '请输入购买单位', trigger: 'change,blur' }],
        rukuzheUserId: [{ required: true, message: '请输入库管员', trigger: 'change,blur' }]
      }

    }
  },
  /** 计算 */
  computed: {
    isEdit() {
      return !!this.entityId
    },
    getTitle() {
      return (this.entityId ? '编辑采购信息' : '新增采购信息')
    },
    getQty() {
      if (this.postForm && this.postForm.guigeQty && this.postForm.shenqingQty) {
        return this.postForm.guigeQty * this.postForm.shenqingQty
      } else {
        return 0
      }
    }

  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D99;F05;F02').then(res => {
      that.allComboxData = res.data.result
    })
    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    show() {
      this.dailogShow = true
    },
    handleClose() {
      this.$refs['postForm'].resetFields()
      this.dailogShow = false
    },
    handleOpen() {
      const that = this
      const path = '/api/services/app/zy02/GetDataCaigou?Id=' + this.entityId

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getNoParams(path).then(res => {
        that.postForm = res.data.result
        that.handleUnitChange()
        if (that.postForm.shenqingQty && that.postForm.caigouDanjia) {
          that.postForm.caigouZongjia = that.postForm.shenqingQty * that.postForm.caigouDanjia
        } else {
          that.postForm.caigouZongjia = undefined
        }
      }).then(_ => {
        that.activeNames = ['CaigouRemark']
        loading.close()
      })
    },
    /** 计算总价 */
    handleSetZongjia() {
      if (this.postForm.shenqingQty && this.postForm.caigouDanjia) {
        this.postForm.caigouZongjia = this.postForm.shenqingQty * this.postForm.caigouDanjia
      } else {
        this.postForm.caigouZongjia = undefined
      }
    },

    /** 保存
     * 1:暂存
     * 2:下单
     */
    handleSave(flag) {
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const that = this
          var path = '/api/services/app/zy02/DoCaigou'

          const postForm = that.postForm
          if (flag === 1) {
            that.postForm.statusDictKey = 'F0102'
          } else if (flag === 2) {
            that.postForm.statusDictKey = 'F0103'
          }

          pathReq.dataUpdate(path, postForm).then(res => {
            that.$message.success('保存成功')
            this.$emit('save-success')
          }).then(_ => {
            that.$refs['postForm'].resetFields()
            this.dailogShow = false
          })
        }
      })
    },
    /** 撤销下单 */
    handleUnSave(endityId) {
      const that = this
      this.$confirm('确定要撤销已下的订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/zy02/UndoXiadang'
        pathReq.dataUpdate(path, { id: that.postForm.id }).then(res => {
          this.$message.success('撤销成功!')
          this.$emit('save-success')
        }).then(_ => {
          that.$refs['postForm'].resetFields()
          this.dailogShow = false
        })
      })
    },
    /** 购买单位变化 */
    handleUnitChange() {
      if (!this.postForm.shenqingUnit) {
        this.postForm.shenqingUnitText = ''
      } else {
        this.postForm.shenqingUnitText = KxjCom.getComboxTextByKey(this.postForm.shenqingUnit, this.getComboxData('F05'))
      }
    }

  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
